module.exports = __webpack_public_path__ + "static/img/07.de5b6cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/07.jpg
// module id = 381
// module chunks = 1